import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoCmrStep2Component
} from './conservazione-carica-documento-cmr-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-cmr-step2', {
            url: '/conservazione-carica-CMR',
            ncyBreadcrumb: {
                label: 'Carica CMR',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-cmr-step2 flex="100"></conservazione-carica-documento-cmr-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoCmrStep2Module: string = ng
    .module('conservazione-carica-documento-cmr-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoCmrStep2', ConservazioneCaricaDocumentoCmrStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-cmr-step2/conservazione-carica-documento-cmr-step2.module.ts